export default __webpack_public_path__ + "src/assets/defizap.3dd41e8c2bda4620d1e0425e59773c8b.svg";